import { render, staticRenderFns } from "./FchzDetail.vue?vue&type=template&id=cf3ab050&scoped=true&"
import script from "./FchzDetail.vue?vue&type=script&lang=js&"
export * from "./FchzDetail.vue?vue&type=script&lang=js&"
import style0 from "../style.css?vue&type=style&index=0&id=cf3ab050&prod&scoped=true&lang=css&"
import style1 from "../detail.css?vue&type=style&index=1&id=cf3ab050&prod&scoped=true&lang=css&"
import style2 from "./FchzDetail.vue?vue&type=style&index=2&id=cf3ab050&prod&scoped=true&lang=css&"
import style3 from "./FchzDetail.vue?vue&type=style&index=3&id=cf3ab050&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf3ab050",
  null
  
)

export default component.exports